export default "__VITE_ASSET__CDJthJkD__";